import React from 'react';

// ── Material icons, inline ───────────────────────────────────────────────────
// The reader's icons, drawn with the same paths as @mui/icons-material. That
// package brings MUI's SvgIcon, emotion and @mui/system into the first
// download (about 65 KiB minified) for a handful of glyphs.
//
// Same props the reader passed to MUI: `fontSize="small"` for 20px, the
// default for 24px, and `style.fontSize` overrides either (the svg is 1em
// square). aria-hidden, as MUI's are: the buttons carry the labels.

const FONT_SIZES = { small: '1.25rem', medium: '1.5rem' };

const makeIcon = (name, path) => {
  const Icon = ({ fontSize = 'medium', style }) => (
    <svg
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      style={{
        display: 'inline-block',
        flexShrink: 0,
        userSelect: 'none',
        fill: 'currentColor',
        transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1)',
        fontSize: FONT_SIZES[fontSize],
        ...style,
      }}
    >
      <path d={path} />
    </svg>
  );
  Icon.displayName = name;
  return Icon;
};

export const StopIcon = makeIcon('StopIcon', 'M6 6h12v12H6z');
export const PauseIcon = makeIcon('PauseIcon', 'M6 19h4V5H6zm8-14v14h4V5z');
export const PlayArrowIcon = makeIcon('PlayArrowIcon', 'M8 5v14l11-7z');
export const DownloadIcon = makeIcon(
  'DownloadIcon',
  'M5 20h14v-2H5zM19 9h-4V3H9v6H5l7 7z'
);
export const ArrowLeftIcon = makeIcon('ArrowLeftIcon', 'm14 7-5 5 5 5z');
export const ArrowRightIcon = makeIcon('ArrowRightIcon', 'm10 17 5-5-5-5z');
export const CloseIcon = makeIcon(
  'CloseIcon',
  'M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
);
export const DeleteIcon = makeIcon(
  'DeleteIcon',
  'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z'
);
export const ExpandMoreIcon = makeIcon(
  'ExpandMoreIcon',
  'M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z'
);
